export default {
      id: "ic-misc-accessibility-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-accessibility-usage",
      toString: function () {
        return this.url;
      }
    }